import { create } from "zustand";

export const selectedServerVersionEdaTableDataStore = create((set) => ({
  selectedServerVersionEdaTableDataZustandState: [],
  setSelectedServerVersionEdaTableData: (data) =>
    set({ selectedServerVersionEdaTableDataZustandState: data }),
}));
